import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  "aria-hidden": "true",
  viewBox: "0 0 20 19"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M14.5 0A3.99 3.99 0 0 0 11 2.1a4.977 4.977 0 0 1 3.9 5.858A3.989 3.989 0 0 0 14.5 0M9 13h2a4 4 0 0 1 4 4v2H5v-2a4 4 0 0 1 4-4" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M5 19h10v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4zM5 7a5.01 5.01 0 0 1 4-4.9 3.988 3.988 0 1 0-3.9 5.859A5 5 0 0 1 5 7m5 3a3 3 0 1 0 0-6 3 3 0 0 0 0 6m5-1h-.424a5 5 0 0 1-1.942 2.232A6.01 6.01 0 0 1 17 17h2a1 1 0 0 0 1-1v-2a5.006 5.006 0 0 0-5-5M5.424 9H5a5.006 5.006 0 0 0-5 5v2a1 1 0 0 0 1 1h2a6.01 6.01 0 0 1 4.366-5.768A5 5 0 0 1 5.424 9" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }